export interface Gender {
  id: number;
  name: string;
}

export const GENDERS: Gender[] = [
  { id: 1, name: 'masculino' },
  { id: 2, name: 'feminino' },
  { id: 3, name: 'outro' },
  { id: 4, name: 'prefiro não dizer' },
  { id: 5, name: 'não informado' }
];

export const getGenderById = (id: number): Gender | undefined => {
  return GENDERS.find(gender => gender.id === id);
};

export const getGenderByName = (name: string): Gender | undefined => {
  return GENDERS.find(gender => gender.name.toLowerCase() === name.toLowerCase());
}; 